<template>
    <section class="article">
        <div class="container faq">
            <div class="row">
                <div class="col-12 head">
                    <h2 class="title">{{ $t('privacy_policy.title') }}</h2>
                </div>
            </div>
            <div class="row text-justify">
                <div class="col-12 pb-5" v-html="$t('privacy_policy.content')">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "PrivacyPolicy"
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/PrivacyPolicy.vue